<div class="invoice-form-wrapper">

  <form *ngIf="form" [formGroup]="form" class="dialog-form" spellcheck="false" autocomplete="off">
    <div class="form-fieldset organization-and-vat">
      <mat-form-field appearance="fill">
        <mat-label>Organisations-/personnummer</mat-label>
        <input matInput formControlName="organizationNumber" />
        <mat-error *ngIf="form.get('organizationNumber')?.touched && form.get('organizationNumber')?.invalid">
          Måste vara mellan 10 - 12 tecken
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Referens</mat-label>
        <input matInput formControlName="reference" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="fill" class="name-field">
      <mat-label>Namn</mat-label>
      <input matInput formControlName="name" />
      <mat-error *ngIf="form.get('name')?.touched && form.get('name')?.hasError('required')">
        Obligatoriskt
      </mat-error>
    </mat-form-field>

    <h5>Kontaktuppgifter</h5>

    <div class="form-fieldset">
      <mat-form-field appearance="fill">
        <mat-label>E-post</mat-label>
        <input matInput formControlName="email" />
        <mat-error *ngIf="form.get('email')?.touched && form.get('email')?.hasError('required')">
          Obligatoriskt
        </mat-error>
        <mat-error *ngIf="form.get('email')?.touched && form.get('email')?.hasError('email')">
          Ogiltig e‑post
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Telefonnummer</mat-label>
        <input matInput formControlName="phone" />
        <mat-error *ngIf="form.get('phone')?.touched && form.get('phone')?.hasError('required')">
          Obligatoriskt
        </mat-error>
        <mat-error *ngIf="form.get('phone')?.touched && form.get('phone')?.hasError('minlength')">
          Minst 7 tecken
        </mat-error>
      </mat-form-field>
    </div>

    <h5>Faktureringsadress</h5>

    <div class="form-fieldset e-invoice-set">
      <mat-checkbox class="e-invoice-check" [formControl]="eInvoiceCheck" color="accent">
        e‑faktura
      </mat-checkbox>

      <mat-form-field appearance="fill" class="e-invoice-address">
        <mat-label>E-post</mat-label>
        <input matInput type="email" formControlName="invoiceEmail" [required]="invoiceEmailRequired" [disabled]="!eInvoiceCheck.value"  />
        <mat-error *ngIf="form.get('invoiceEmail')?.touched && form.get('invoiceEmail')?.hasError('required')">
          Obligatoriskt
        </mat-error>
        <mat-error *ngIf="form.get('invoiceEmail')?.touched && form.get('invoiceEmail')?.hasError('email')">
          Ogiltig e‑post
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-fieldset address-and-zip">
      <mat-form-field appearance="fill" class="address-field">
        <mat-label>Adress</mat-label>
        <input matInput formControlName="address" />
        <mat-error *ngIf="form.get('address')?.touched && form.get('address')?.hasError('required')">
          Obligatoriskt
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="zip-field">
        <mat-label>Postnummer</mat-label>
        <input matInput formControlName="zip" />
        <mat-error *ngIf="form.get('zip')?.touched && form.get('zip')?.hasError('required')">
          Obligatoriskt
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-fieldset">
      <mat-form-field appearance="fill">
        <mat-label>Stad</mat-label>
        <input matInput formControlName="city" />
        <mat-error *ngIf="form.get('city')?.touched && form.get('city')?.hasError('required')">
          Obligatoriskt
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Land</mat-label>
        <input matInput formControlName="country" />
        <mat-error *ngIf="form.get('country')?.touched && form.get('country')?.hasError('required')">
          Obligatoriskt
        </mat-error>
      </mat-form-field>
    </div>

  </form>
</div>